import { useNavigate } from "react-router-dom";

const ESTADO_RECLAMO = {
    abierto:                    { label: "Abierto",              cls: "bg-danger-subtle text-danger-emphasis border border-danger-subtle",         icono: "bi-exclamation-circle-fill" },
    en_revision:                { label: "En revisión",          cls: "bg-warning-subtle text-warning-emphasis border border-warning-subtle",       icono: "bi-search"                  },
    resuelto_a_favor_comprador: { label: "→ Comprador",          cls: "bg-primary-subtle text-primary-emphasis border border-primary-subtle",       icono: "bi-person-check-fill"       },
    resuelto_a_favor_proveedor: { label: "→ Vendedor",           cls: "bg-success-subtle text-success-emphasis border border-success-subtle",       icono: "bi-person-fill-check"       },
    cerrado:                    { label: "Cerrado",               cls: "bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle", icono: "bi-check-circle"            },
};

function fmtFecha(f) {
    if (!f) return "—";
    return new Date(f).toLocaleString("es-CO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

function AvatarUser({ u }) {
    if (!u) return <span className="text-muted small">—</span>;
    const nombre = [u.nombre, u.apellido].filter(Boolean).join(" ") || u.username || "—";
    return (
        <div className="d-flex align-items-center gap-2">
            <img src={u.avatar || "/imagenes/marca/avatar.png"} alt={u.username} className="rounded-circle flex-shrink-0" style={{ width: 28, height: 28, objectFit: "cover" }} />
            <div style={{ lineHeight: 1.2 }}>
                <div className="small fw-semibold text-dark text-truncate" style={{ maxWidth: 120 }}>{nombre}</div>
                <div className="text-muted" style={{ fontSize: "0.7rem" }}>@{u.username || "—"}</div>
            </div>
        </div>
    );
}

function ListaReclamos({ reservas = [], total = 0, pagina = 1, paginas = 1, onPagina }) {
    const navigate = useNavigate();

    const inicio = (pagina - 1) * 20;
    const fin    = inicio + reservas.length;

    return (
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="card-header bg-white border-0 p-4 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="fw-bold mb-1">Reclamos</h5>
                    <p className="text-secondary mb-0 small">Reservas con disputa abierta por el comprador.</p>
                </div>
                <span className="badge rounded-pill bg-light text-dark border px-3 py-2">{total} reclamo{total !== 1 ? "s" : ""}</span>
            </div>

            <div className="card-body p-0">
                {reservas.length === 0 ? (
                    <div className="p-5 text-center text-muted">
                        <i className="bi bi-shield-check fs-2 d-block mb-2" style={{ opacity: 0.3 }}></i>
                        <span className="small">No hay reclamos con los filtros actuales.</span>
                    </div>
                ) : (
                    <>
                        {/* Tabla escritorio */}
                        <div className="d-none d-lg-block overflow-x-auto">
                            <table className="table table-hover align-middle mb-0" style={{ fontSize: "0.85rem" }}>
                                <thead className="table-light">
                                    <tr>
                                        <th className="ps-4 fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Apertura</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Servicio</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Comprador</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Vendedor</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Motivo</th>
                                        <th className="fw-semibold text-muted" style={{ fontSize: "0.72rem", textTransform: "uppercase" }}>Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reservas.map((r) => {
                                        const cfg = ESTADO_RECLAMO[r.reclamo?.estado] || ESTADO_RECLAMO.abierto;
                                        return (
                                            <tr key={r._id} style={{ cursor: "pointer" }}
                                                onClick={() => navigate("/admin/reclamo", { state: { params: { idReserva: r._id } } })}>
                                                <td className="ps-4 text-muted" style={{ whiteSpace: "nowrap", fontSize: "0.82rem" }}>
                                                    {fmtFecha(r.reclamo?.fechaApertura || r.createdAt)}
                                                </td>
                                                <td>
                                                    <div className="fw-semibold text-dark text-truncate" style={{ maxWidth: 180, fontSize: "0.85rem" }}>
                                                        {r.nombreServicio || "—"}
                                                    </div>
                                                    <div className="text-muted" style={{ fontSize: "0.72rem" }}>{r.tipoPaquete || "—"}</div>
                                                </td>
                                                <td><AvatarUser u={r.comprador} /></td>
                                                <td><AvatarUser u={r.proveedor} /></td>
                                                <td>
                                                    <span className="text-dark text-truncate d-block" style={{ maxWidth: 200, fontSize: "0.82rem" }}>
                                                        {r.reclamo?.motivo || "—"}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`badge rounded-pill px-2 py-1 ${cfg.cls}`} style={{ fontSize: "0.7rem" }}>
                                                        <i className={`bi ${cfg.icono} me-1`}></i>{cfg.label}
                                                    </span>
                                                </td>
                                                <td><i className="bi bi-chevron-right text-muted" style={{ fontSize: "0.75rem" }}></i></td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        {/* Lista móvil */}
                        <div className="d-lg-none list-group list-group-flush">
                            {reservas.map((r) => {
                                const cfg = ESTADO_RECLAMO[r.reclamo?.estado] || ESTADO_RECLAMO.abierto;
                                return (
                                    <div key={r._id} className="list-group-item p-3" style={{ cursor: "pointer" }}
                                        onClick={() => navigate("/admin/reclamo", { state: { params: { idReserva: r._id } } })}>
                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                            <div className="fw-semibold text-dark" style={{ fontSize: "0.9rem" }}>{r.nombreServicio || "—"}</div>
                                            <span className={`badge rounded-pill px-2 py-1 ms-2 flex-shrink-0 ${cfg.cls}`} style={{ fontSize: "0.7rem" }}>
                                                <i className={`bi ${cfg.icono} me-1`}></i>{cfg.label}
                                            </span>
                                        </div>
                                        <div className="text-muted small text-truncate mb-1">{r.reclamo?.motivo || "—"}</div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <AvatarUser u={r.comprador} />
                                            <div className="text-muted" style={{ fontSize: "0.72rem" }}>{fmtFecha(r.reclamo?.fechaApertura)}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>

            <div className="card-footer bg-white border-0 p-3 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3">
                <small className="text-secondary">
                    {reservas.length > 0 ? `${inicio + 1}–${fin} de ${total}` : "Sin resultados"}
                </small>
                <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-light border rounded-pill px-3 btn-sm" disabled={pagina <= 1} onClick={() => onPagina(pagina - 1)}>Anterior</button>
                    <span className="small text-secondary">Pág. {pagina} de {paginas}</span>
                    <button className="btn btn-light border rounded-pill px-3 btn-sm" disabled={pagina >= paginas} onClick={() => onPagina(pagina + 1)}>Siguiente</button>
                </div>
            </div>
        </div>
    );
}

export default ListaReclamos;
